import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';

import AppButton from '../../../components/Button/AppButton/AppButton';
import ConnectionTrackButton from '../../../components/Button/ConnectionTrackButton/ConnectionTrackButton';
import {ErrorModalTemplate} from '../../../components/DataDisplay';
import * as localizationKeys from '../../../consts/localization/localizationKeys';
import connectivityService from '../../../services/device/connectivityService';
import fwuService from '../../../services/device/fwuService';
import fwuTargetService from '../../../services/device/fwuTargetService';
import fwuPackageService from '../../../services/fwu/fwuPackageService';
import {getLocalizedStrings} from '../../../services/localization/localizationService';
import modalService from '../../../services/modalService';
import {makeSelectIsStartAutoSync} from '../../../state/selectors/global';
import {
    makeSelectIotDeviceData,
    selectIsDeviceDisconnected,
    selectIsDevicePaired,
} from '../../../state/selectors/iotDevice';

const DeviceInSblModePopup = (props) => {
    const {modalType, fwu_target} = props;
    const isBle = connectivityService.isBle();
    const isDeviceDisconnected = useSelector(selectIsDeviceDisconnected);
    const isDevicePaired = useSelector(selectIsDevicePaired);
    const isStartAutoSync = useSelector(makeSelectIsStartAutoSync());
    const localizedStrings = getLocalizedStrings();
    const isFwuTargetHolderRelated = fwuTargetService.isFwuTargetHolderRelated(fwu_target);
    const {device} = useSelector(makeSelectIotDeviceData()) || {};
    const {isHolderConnected} = device || {};
    const doesDeviceSupportSblUpdate = fwuPackageService.checkIfDeviceSupportsSblUpdate(fwu_target);
    const isFwuTargetRequiresUsbConnection = fwuTargetService.isFwuTargetRequiresUsbConnection(
        fwu_target,
        doesDeviceSupportSblUpdate
    );
    const isUsbConnectionRequired = isBle && isFwuTargetRequiresUsbConnection;
    const hideModal = () => modalService.hideModal(modalType);

    const onClick = () => {
        hideModal();

        if (isUsbConnectionRequired) return;

        const availableFwuPackages = fwuPackageService.getFwuPackagesStatic();

        if (!availableFwuPackages.length) return;
        fwuService.initiateUpdateFirmwareMessage(availableFwuPackages[0].target);
    };
    const onClose = () => hideModal();

    useEffect(() => {
        if (isDeviceDisconnected || (isFwuTargetHolderRelated && !isHolderConnected) || isDevicePaired) {
            hideModal();
        }
    }, [isDeviceDisconnected, isHolderConnected, isDevicePaired]);

    const titleKey = isFwuTargetHolderRelated
        ? localizationKeys.HOLDER_IN_SBL_USB_UPDATE_POPUP_TITLE_TEXT
        : localizationKeys.CHARGER_IN_SBL_USB_UPDATE_POPUP_TITLE_TEXT;
    const descriptionKey = isFwuTargetHolderRelated
        ? localizationKeys.HOLDER_IN_SBL_USB_UPDATE_POPUP_MESSAGE_TEXT
        : localizationKeys.CHARGER_IN_SBL_USB_UPDATE_POPUP_MESSAGE_TEXT;

    let btnKey = localizationKeys.CHARGER_IN_SBL_USB_UPDATE_POPUP_UPDATE_BUTTON_TEXT;

    if (isUsbConnectionRequired) {
        btnKey = localizationKeys.HOLDER_IN_SBL_BLE_UPDATE_POPUP_OK_BUTTON_TEXT;
    } else if (isFwuTargetHolderRelated) {
        btnKey = localizationKeys.HOLDER_IN_SBL_USB_UPDATE_POPUP_UPDATE_BUTTON_TEXT;
    }

    return isStartAutoSync ? (
        <ErrorModalTemplate
            titleKey={titleKey}
            descriptionKey={descriptionKey}
            onClose={isUsbConnectionRequired ? onClose : undefined}
        >
            <ConnectionTrackButton button={AppButton} primary light onClick={onClick}>
                {localizedStrings[btnKey]}
            </ConnectionTrackButton>
        </ErrorModalTemplate>
    ) : null;
};

export default DeviceInSblModePopup;
